import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './Services.css';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import dmeets_logo from '../../Assets/Dmeets_Logo_App.png';
import sme_logo from '../../Assets/sme_mate_logo.png';
import dtime_logo from '../../Assets/DTime_Logo(transparent).png';
import service_us from '../../Assets/service1.jpg';
import custom_support from '../../Assets/custom_support.jpg';
import dmeets_call from '../../Assets/dmeets_call.jpg';
import staper from '../../Assets/staper.png';


function Services() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth < 767); // ปรับขนาดที่ 600px ตามสมควร
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // เรียกใช้ฟังก์ชั่นเมื่อโหลดหน้าเว็บ
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (

            <Container style={{marginBottom: "50px"}} className='pad10'>
                <Row>
                    <Col xs={12} md={8} style={{margin: "auto"}}>
                        <Row className="align-items-center">
                            <Col xs={12} md={12} lg={7} xl={7} className='Service-container' >
                                <Row>
                                    <span className='service-heading'>{t('Our Services')}</span>
                                </Row>
                                <Row>
                                    <span className='service-details'>{t("At ")} <b>{t("DCM")}</b> {t(" , we provide more than just software — we deliver digital solutions designed to empower your business. Our services are built to increase efficiency, improve compliance, and support your long-term growth in today’s digital-first world.")}</span>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Button 
                                            className='contactus-btn' 
                                            variant="outlined-primary" 
                                            size="lg"
                                            onClick={() => navigate('/contact-us')}
                                        >{t('Contact Us')}</Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} md={12} lg={5} xl={5} className='Service-img-container'>
                                <img  className='Service-img' src={service_us} alt="Service" />
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "70px"}}>
                            <Col xs={12} md={12} lg={12} xl={12} className='Service-container' >
                                <Row>
                                    <span className='home-content-heading'>{t('Business Software Solutions')}</span>
                                </Row>
                                <Row style={{ paddingTop: "15px"}}> 
                                    <span className='service-details'>{t("Delivering ready-to-use platforms tailored for modern Thai businesses.")}</span>
                                </Row>
                                <Row className="align-items-center resplogo20" >
                                    <Col xs="auto" className="logo-col">
                                        <img src={dtime_logo} alt="dtime-logo" className="logo-img" />
                                    </Col>
                                    <Col style={{ marginLeft: "-20px" }}>
                                        <span className="con-ser-sub"  style={{ lineHeight: "1" }}>{t('DTime – Time & Attendance Management')}</span>
                                    </Col>
                                </Row>

                                <Row className='resplogo10'>
                                    <Col xs="auto" className="logo-col">
                                        {/* ช่องว่างขนาดเท่ากัน */}
                                        <div className="logo-placeholder" />
                                    </Col>
                                    <Col style={{ marginLeft: "-20px" }}>
                                        <Row>
                                            <span className='service-details'>{t("A smart, digital system for tracking employee time, managing leave requests, and handling petty cash – all in one centralized platform.")}</span>
                                        </Row>
                                        <Row className='licssh'>
                                            <span className='home-aboutus'>{t("Features: ")}</span>
                                        </Row>
                                        <Row style={{ marginTop: "12px" }}>
                                            <li><span className='service-details' >{t("Web & mobile check-in/out")}</span></li>
                                            <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("Leave, expense & overtime approvals")}</span></li>
                                            <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("Real-time activity reports")}</span></li>
                                            <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("PDPA-compliant data storage")}</span></li>    
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="align-items-center" style={{ marginLeft: "-25px", marginTop: "20px" }}>
                                    <Col xs="auto" className="logo-col">
                                        <img src={dmeets_logo} alt="dtime-logo" className="logo-img" />
                                    </Col>
                                    <Col style={{ marginLeft: "-20px" }}>
                                        <span className="con-ser-sub" style={{ lineHeight: "1" }}>{t('Dmeets – Online Meeting with Legal Support')}</span>
                                    </Col>
                                </Row>

                                <Row className='resplogo10'>
                                    <Col xs="auto" className="logo-col">
                                        {/* ช่องว่างขนาดเท่ากัน */}
                                        <div className="logo-placeholder" />
                                    </Col>
                                    <Col style={{ marginLeft: "-20px" }}>
                                        <Row>
                                            <span className='service-details'>{t("A secure video conferencing platform with meeting minutes prepared by qualified legal professionals.")}</span>
                                        </Row>
                                        <Row className='licssh'>
                                            <span className='home-aboutus'>{t("Ideal for: ")}</span>
                                        </Row>
                                        <Row style={{ marginTop: "12px" }}>
                                            <li><span className='service-details' >{t("Executive and board meetings")}</span></li>
                                            <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("Shareholder meetings")}</span></li>
                                            <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("Compliance-sensitive discussions")}</span></li>   
                                        </Row>
                                        <Row style={{ marginTop: "12px" }}>
                                            <span className='home-aboutus'>{t("Benefits: ")}</span>
                                        </Row>
                                        <Row style={{ marginTop: "12px" }}>
                                            <li><span className='service-details' >{t("Legal-grade minutes & documentation")}</span></li>
                                            <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("Thai-language support")}</span></li>
                                            <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("Stored securely within Thailand")}</span></li>    
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "70px"}}>
                            <Col xs={12} md={12} lg={12} xl={12} className='Service-container' >
                                <Row>
                                    <span className='home-content-heading'>{t('Digital Transformation Services')}</span>
                                </Row>
                                <Row style={{ paddingTop: "15px"}}> 
                                    <span className='service-details'>{t("Helping your organization shift from paper-based processes to secure, digital-first workflows.")}</span>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12} lg={6} xl={6} className='mgtop10'>
                                        <Row>
                                            <Col xs={12} md={12}> 
                                                <Row className='number-span'>
                                                    <span className='home-aboutus'>{t('Custom Software Development')}</span>
                                                </Row>
                                                <Row style={{ marginTop: "20px"}}>
                                                    <span className='service-content'>{t('We build tailored systems to fit your operations and integrate with your tools.')}</span>
                                                </Row>
                                                <Row style={{ marginTop: "20px"}}>
                                                    <li><span className='service-details' >{t("Business process automation")}</span></li>
                                                    <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("Workflow-specific modules")}</span></li>
                                                    <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("Scalable cloud systems")}</span></li> 
                                                    <li style={{ paddingTop: "8px"}}><span className='service-details' >{t("UX/UI design by experienced professionals")}</span></li> 
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12} md={12} lg={6} xl={6} className='mgtop'>
                                        <Row>
                                            <Col xs={12} md={12} >
                                                <Row className='number-span'>
                                                    <span className='home-aboutus'>{t('Web & Mobile Application Development')}</span>
                                                </Row>
                                                <Row style={{ marginTop: "20px"}}>
                                                    <span className='service-content'>{t('Launch your online presence or build internal apps that match your needs.')}</span>
                                                </Row>
                                                <Row style={{ marginTop: "20px"}}>
                                                    <li><span className='service-details'>{t("Responsive websites & admin panels")}</span></li>
                                                    <li style={{ paddingTop: "8px"}}><span className='service-details'>{t("Mobile apps (iOS/Android)")}</span></li> 
                                                    <li style={{ paddingTop: "8px"}}><span className='service-details'>{t("Internal portals or e-service tools")}</span></li> 
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "70px"}} className="align-items-center pd10">

                            <Col xs={12} md={12} lg={5} xl={5} className='Service-img-container'>
                                <img  className='Service-img' src={custom_support} alt="Service" />
                            </Col>
                            <Col xs={12} md={12} lg={7} xl={7} className='Service-container pdtop' >
                                <Row>
                                    <span className='home-content-heading'>{t('Need a Custom Solution?')}</span>
                                </Row>
                                <Row style={{marginTop: "10px"}}>
                                    <span className='fslast'>{t("Our team is ready to design, develop, and support solutions tailored to your industry and operational needs.")}</span>
                                </Row>
                                <Row style={{marginTop: "20px"}}>
                                    <span className='fslast'><i className="bi bi-envelope-arrow-down" style={{ marginRight: "8px", color: "#212529" }}></i><b>{t("Get in touch with us today ")}</b>{t("to discuss how DCM can support your digital goals.")}</span>
                                </Row>
                                <Row style={{marginTop: "30px"}}>
                                    <Col xs={12}>
                                        <Button 
                                            className='contactus-btn' 
                                            style={{
                                                backgroundColor: "#afcbf8",
                                                border: "none"  
                                            }}
                                            size="lg"
                                            onClick={() => navigate('/contact-us')}
                                        ><span style={{ color: "#212529" }}>{t('Contact Us')}</span></Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>    
                </Row>
                {/* <Row className='justify-content-md-center service-row'>
                    <span className='home-content-heading'>{t('Seamless Business Operations')}</span>
                    <Col  xs={12} md={4} className="about-us-col col-ser" >
                        <span className='home-aboutus'>{t('Streamlined Workflows')}</span><br />
                        <span className='home-content'>{t('Our agile software applications help you reduce business restrictions and effectively manage your time.')}</span>
                    </Col>
                    <Col  xs={12} md={4} className="about-us-col col-ser">
                        <span className='home-aboutus'>{t('Comprehensive Support')}</span><br />
                        <span className='home-content'>{t('We provide the necessary support to help you build and maintain your business with our customizable solutions.')}</span>
                    </Col>
                    <Col  xs={12} md={4} className="about-us-col col-ser">
                        <span  className='home-aboutus'>{t('Increased Productivity')}</span><br />
                        <span className='home-content'>{t('Boost your efficiency and focus on growth with our software designed to keep your business on track.')}</span>
                    </Col>
                </Row>
                <Row className='justify-content-md-center service-row ' >
                    <Col xs={12} md={7} className='Service-container'>
                        <Row>
                            <span className='home-content-heading'>{t('Dmeets: Secure Online Meetings')}</span>
                        </Row>
                        <Row>
                            <span className='service-details'>{t("Keep your online meetings safe and secure. Whether you're the host or a partscipant, Dmeets makes it simple and easy. Enjoy our online meeting platform for your business - and it starts ")} <b>{t('free.')}</b></span>
                        </Row>
                        <Row className='d-flex mt-4'>
                            <Col xs={2} md={2} >
                                <img className="app-logo" src={dmeets_logo} alt="dmeets-logo" />
                            </Col>
                            <Col xs={9} md={9} className='ling-web'>
                                <span className='home-content'>
                                    {t("Visit our ")}
                                    <a className="app-link" href="https://dmeets.dcm.co.th/">{t('Dmeets website')}</a>
                                    {t(" to learn more.")}
                                </span>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={5} className='Service-img-container'>
                        <img  className='Service-img' src={dmeets_call} alt="dmeets_call" />
                    </Col>
                </Row>
                <Row className='justify-content-md-center mb-5' style={{marginTop: "150px"}}>
                    <Col xs={10} md={10}><span className='home-content-heading'>{t('SME Mate: Empower Your SME')}</span></Col>
                    <Col xs={2} md={2}><img className="app-logo-right" src={sme_logo} alt="sme-logo" /></Col>
                        
                </Row>
                <Row>
                    <Col  xs={12} md={4} className="about-us-col col-ser" >
                        <Row>
                            <Col xs={1} md={2}>
                                <i className="bi bi-1-square-fill home-aboutus-number"></i>
                            </Col>
                            <Col xs={11} md={10} className='home-aboutus-number-descript'> 
                                <Row>
                                    <span className='home-aboutus'>{t('Streamlined Workflows')}</span>
                                </Row>
                                <Row style={{marginTop: "10px"}}>
                                <span className='service-content'>{t('Manage your business on-the-go with our intuitive web and mobile applications.')}</span>
                                </Row>
                                
                                
                            </Col>
                            
                        </Row>
                    </Col>
                    <Col  xs={12} md={4} className="about-us-col col-ser" >
                        <Row>
                            <Col xs={1} md={2}>
                                <i className="bi bi-2-square-fill home-aboutus-number"></i>
                            </Col>
                            <Col xs={11} md={10} className='home-aboutus-number-descript'> 
                                <Row>
                                    <span className='home-aboutus'>{t('Optimized Operations')}</span>
                                </Row>
                                <Row style={{marginTop: "10px"}}>
                                    <span className='service-content'>{t("Empower your SME's success by streamlining and enhancing your core business processes.")}</span>
                                </Row>
                            </Col>
                            
                        </Row>
                    </Col>
                    <Col  xs={12} md={4} className="about-us-col col-ser" >
                        <Row>
                            <Col xs={1} md={2}>
                                <i className="bi bi-3-square-fill home-aboutus-number"></i>
                            </Col>
                            <Col xs={11} md={10} className='home-aboutus-number-descript'> 
                                <Row>
                                    <span className='home-aboutus'>{t('All-in-One Platform')}</span>
                                </Row>
                                <Row style={{marginTop: "10px"}}>
                                    <span className='service-content'>{t('Consolidate your document workflows and operations with our comprehensive, integrated platform.')}</span>
                                </Row>
                            </Col>
                            
                        </Row>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <span className='home-content'>
                        {t("Check out our full service at ")}
                        <a className="app-link" href="https://smemate.dcm.co.th/home">{t('SME MATE.')}</a>
                    </span>
                </Row>
                <Row className='justify-content-md-center dtime-row'>
                    <Col xs={12}>
                        <Row >
                            <Col xs={2} md={1}><img className="app-logo-dtime" src={dtime_logo} alt="dtime-logo" /></Col>
                            <Col xs={10} md={11} className='ditem-letf'><span className='home-content-heading logo-dtime'>{t('Streamline Your Business with DTime')}</span></Col>
                        </Row>
                        <Row style={{ paddingTop: "20px"}}>
                            <Col xs={12}>
                                <span className='home-content'>
                                    {t("Efficient Business Management Software for Growing Companies")}
                                </span>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "30px"}}>
                            <Col xs={12}>
                                <span className='service-content-sub-heading'>{t('Key Features of DTime:')}</span>
                            </Col>
                        </Row>
                        <Row className='justify-content-md-center home-aboutus-row' style={{ paddingTop: "20px"}}>
                            <Col xs={12} md={6}>
                                <Row>
                                    <Col xs={1} md={1}>
                                    <i className="bi bi-1-square-fill home-aboutus-number"></i>
                                    </Col>
                                    <Col xs={11} md={11} className='home-aboutus-number-descript'> 
                                    <Row className='number-span'>
                                        <span className='home-content-subheading'>{t('Leave Requests')}</span>
                                    </Row>
                                    <Row>
                                        <span className='service-content'>{t('Automate and manage leave applications with ease. Approve requests, track balances, and maintain records effortlessly.')}</span>
                                    </Row>
                                    </Col>
                                </Row>
                                </Col>
                            <Col xs={12} md={6}>
                                <Row>
                                    <Col xs={1} md={1}>
                                    <i className="bi bi-2-square-fill home-aboutus-number"></i>
                                    </Col>
                                    <Col xs={11} md={11} className='home-aboutus-number-descript'>
                                    <Row className='number-span'>
                                        <span className='home-content-subheading'>{t('Timesheet Management')}</span>
                                    </Row>
                                    <Row>
                                        <span className='service-content'>{t('Simplify time tracking with automated timesheet entries and approvals to ensure accurate payroll.')}</span>
                                    </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center home-aboutus-row">
                            <Col xs={12} md={6}>
                                <Row>
                                    <Col xs={1} md={1}>
                                    <i className="bi bi-3-square-fill home-aboutus-number"></i>
                                    </Col>
                                    <Col xs={11} md={11} className='home-aboutus-number-descript'>
                                    <Row className='number-span'>
                                        <span className='home-content-subheading'>{t('Invoicing')}</span>
                                    </Row>
                                    <Row>
                                        <span className='service-content'>{t('Generate and manage invoices quickly, improving cash flow with timely and professional billing.')}</span>
                                    </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} md={6}>
                                <Row>
                                    <Col xs={1} md={1}>
                                    <i className="bi bi-4-square-fill home-aboutus-number"></i>
                                    </Col>
                                    <Col xs={11} md={11} className='home-aboutus-number-descript'>
                                    <Row className='number-span'>
                                        <span className='home-content-subheading'>{t('Receipt Management')}</span>
                                    </Row>
                                    <Row>
                                        <span className='service-content'>{t('Easily create and organize receipts, keeping your financial records accurate and audit-ready.')}</span>
                                    </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="justify-content-md-center home-aboutus-row">
                            <Col xs={12} md={6}>
                                <Row>
                                    <Col xs={1} md={1}>
                                    <i className="bi bi-5-square-fill home-aboutus-number"></i>
                                    </Col>
                                    <Col xs={11} md={11} className='home-aboutus-number-descript'>
                                    <Row className='number-span'>
                                        <span className='home-content-subheading'>{t('Sales Orders')}</span>
                                    </Row>
                                    <Row>
                                        <span className='service-content'>{t('Automate sales order processing to enhance accuracy and customer satisfaction, while integrating seamlessly with inventory systems.')}</span>
                                    </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} md={6}>
                                <Row>
                                    <Col xs={1} md={1}>
                                    <i className="bi bi-6-square-fill home-aboutus-number"></i>
                                    </Col>
                                    <Col xs={11} md={11} className='home-aboutus-number-descript'>
                                    <Row className='number-span'>
                                        <span className='home-content-subheading'>{t('Customization')}</span>
                                    </Row>
                                    <Row>
                                        <span className='service-content'>{t('Tailor DTime to meet your specific business needs, enhancing functionality as your business grows.')}</span>
                                    </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "30px"}}>
                            <Col xs={12}>
                                <span className='service-content-sub-heading'>{t('Why Choose DTime?')}</span>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "30px"}}>
                            <Col  xs={12} md={4} className="service-us-col" >
                                <Card className='card-service-dtime'>
                                    <Card.Body>
                                        <Row>
                                            <span className='home-aboutus'>{t('Boost Efficiency')}</span>
                                        </Row>
                                        <Row style={{marginTop: "10px"}}>
                                        <span className='service-content'>{t('Automate routine tasks, reduce manual errors, and focus on strategic goals.')}</span>
                                        </Row>   
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col  xs={12} md={4} className="service-us-col" >
                                <Card className='card-service-dtime'>
                                    <Card.Body>
                                        <Row>
                                            <span className='home-aboutus'>{t('Increase Transparency')}</span>
                                        </Row>
                                        <Row style={{marginTop: "10px"}}>
                                        <span className='service-content'>{t('Gain real-time insights into your business operations for better decision-making.')}</span>
                                        </Row>   
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col  xs={12} md={4} className="service-us-col" >
                                <Card className='card-service-dtime'>
                                    <Card.Body>
                                        <Row>
                                            <span className='home-aboutus'>{t('Scale with Ease')}</span>
                                        </Row>
                                        <Row style={{marginTop: "10px"}}>
                                        <span className='service-content'>{t('Support your business growth with scalable solutions that handle increasing complexity.')}</span>
                                        </Row>   
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "20px"}}>
                            <Col xs={12}>
                                <span className='service-content'>
                                    {t("Empower Your Business Today with DTime – The Smart Way to Manage Your Business Operations!")}
                                </span>
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "20px"}}>
                            <Col xs={12}>
                            <span className='home-content'>             
                                <a className="app-link" href="https://dtimeadmin.dcm.co.th/register-company">{t('Register')}</a>
                                {t(" your company and start using DTime!")}
                            </span>
                            </Col>
                        </Row>
                    </Col>
  
                </Row>
                <Row className='justify-content-md-center ' style={{marginTop: "150px"}}>
                    <Col xs={12}>
                        <Row>
                            <Col xs={12} md={12}><span className='home-content-heading'>{t('Why DCM?')}</span></Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='justify-content-md-center' style={{marginTop: "20px"}}>
                    <div class="container">
                        <div class="main-timeline">
                            <div class="timeline">
                                <div class="icon"></div>
                                <div class="date-content">
                                    <div class="date-outer">
                                        <span class="date">
                                            <span class="year">1</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="timeline-content">
                                    <h5 class="title">{t("Expertise")}</h5>
                                    <p class="description">
                                        {t("Our team of skilled professionals has the expertise to deliver tailored software solutions.")}
                                    </p>
                                </div>
                            </div>

                            <div class="timeline">
                                <div class="icon"></div>
                                <div class="date-content">
                                    <div class="date-outer">
                                        <span class="date">
                                
                                        <span class="year">2</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="timeline-content">
                                    <h5 class="title">{t("Customization")}</h5>
                                    <p class="description">
                                        {t("We work closely with clients to understand their unique needs and provide customizable applications.")}
                                    </p>
                                </div>
                            </div>

                            <div class="timeline">
                                <div class="icon"></div>
                                <div class="date-content">
                                    <div class="date-outer">
                                        <span class="date">
                        
                                        <span class="year">3</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="timeline-content">
                                    <h5 class="title">{t("Continuous Innovation")}</h5>
                                    <p class="description">
                                        {t("We are committed to ongoing development to ensure our software remains cutting-edge.")}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row className=" justify-content-md-center card-contact">
                    <Card className='card-contact-panding'>
                    <Card.Body>
                        <Card.Title><span className='home-content-heading'>{t('Start Transforming Your Business Today')}</span></Card.Title>
                        {
                            !isMobile ? (
                                <>
                                    <Card.Title >
                                        <Row className='d-flex justify-content-md-center align-items-center '>
                                            <Col xs={12}>
                                                <img  className='Service-img' src={staper} alt="Service" />
                                            </Col>
                                        </Row>
                                    </Card.Title>
                                    <Card.Title style={{marginBottom: "20px",paddingLeft: "35px"}}>
                                        <Row className='justify-content-md-center'>
                                            <Col  xs={12} md={4} className="about-us-col col-ser" >
                                                <Row className='pb-3'>
                                                    <span className='home-aboutus'>{t('Explore')}</span>
                                                </Row>
                                                <Row>
                                                    <span className='home-content'>{t('Check out our suite of software solutions.')}</span>
                                                </Row>
                                            </Col>
                                            <Col  xs={12} md={4} className="about-us-col col-ser">
                                                <Row className='pb-3'>
                                                    <span className='home-aboutus'>{t('Connect')}</span>
                                                </Row>
                                                <Row>
                                                    <span className='home-content'>{t('Schedule a consultation with our experts.')}</span>
                                                </Row>        
                                            </Col>
                                            <Col  xs={12} md={4} className="about-us-col col-ser">
                                                <Row className='pb-3'>
                                                    <span  className='home-aboutus'>{t('Innovate')}</span>
                                                </Row>
                                                <Row>
                                                    <span className='home-content'>{t('Unlock your business potential with DCM.')}</span>
                                                </Row>     
                                            </Col>
                                        </Row>
                                    </Card.Title>
                                </>
                            ) : (
                                <>
                                    <Card.Title style={{marginBottom: "20px"}}>
                                        <Row className='justify-content-md-center'>
                                            <Col  xs={12} md={4} className="mt-3 pb-4 col-ser" >
                                                <Row>
                                                    <Col xs={1} md={2}>
                                                        <i className="bi bi-1-square-fill home-aboutus-number"></i>
                                                    </Col>
                                                    <Col xs={11} md={10} className='home-aboutus-number-descript'> 
                                                        <Row className='pb-2'>
                                                            <span className='home-aboutus'>{t('Explore')}</span>
                                                        </Row>
                                                        <Row>
                                                            <span className='home-content'>{t('Check out our suite of software solutions.')}</span>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col  xs={12} md={4} className="pb-4 col-ser">
                                                <Row>
                                                    <Col xs={1} md={2}>
                                                        <i className="bi bi-2-square-fill home-aboutus-number"></i>
                                                    </Col>
                                                    <Col xs={11} md={10} className='home-aboutus-number-descript'> 
                                                        <Row className='pb-2'>
                                                            <span className='home-aboutus'>{t('Connect')}</span>
                                                        </Row>
                                                        <Row>
                                                            <span className='home-content'>{t('Schedule a consultation with our experts.')}</span>
                                                        </Row>  
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col  xs={12} md={4} className="pb-4 col-ser">
                                                <Row>
                                                    <Col xs={1} md={2}>
                                                        <i className="bi bi-3-square-fill home-aboutus-number"></i>
                                                    </Col>
                                                    <Col xs={11} md={10} className='home-aboutus-number-descript'> 
                                                        <Row className='pb-2'>
                                                            <span  className='home-aboutus'>{t('Innovate')}</span>
                                                        </Row>
                                                        <Row>
                                                            <span className='home-content'>{t('Unlock your business potential with DCM.')}</span>
                                                        </Row>     
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Title>
                                </>
                            )
                        }
                        <Button 
                            className='learnmore-btn' 
                            variant="primary" 
                            size="lg" 
                            style={{ marginTop: '1%'}}
                            onClick={() => navigate('/contact-us')}
                            >
                            {t('Contact Us')}
                        </Button>
                       
                        </Card.Body>
                    </Card>
                </Row> */}
            </Container>
    );
}

export default Services;